import React, { useState } from 'react'
import { Button, ClickAwayListener, MenuItem, MenuList, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../reducers/form';
import { typeGant } from '../../enum/gant.enum'
function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}

const typesView = new Set(['material', 'work', 'textField']);

const processActionHide = (old,value, formName, formTypeRow, arrHide, setArrHide) => (dispatch, getState) => {
  const state = getState()
  const byId = state.form?.[formName]?.values.byId || {}
  const tree = state.gant
  const allIds = tree.flat.map(e => 'id' + e.id)
  if (old) {
    const arrAdd = []
    allIds.forEach(key => {
      if (byId[key].typeGant === value) arrAdd.push(key)
    })
    dispatch(actions.formArrayAddManyUnique(arrAdd, { field: 'arrTypeFilter', name: formName }))
    setArrHide(e => ({ ...e, [value]: arrAdd }))
  }
  else {
    dispatch(actions.formArrayDeleteMany(arrHide[value], { field: 'arrTypeFilter', name: formName }))
    setArrHide(e => ({ ...e, [value]: [] }))
  }
  dispatch(actions.formChange(!old, { field: value, name: formTypeRow }))
}

export default function GantDialogTypeView({ formTypeRow, formName }) {
  const dispatch = useDispatch()
  const anchorRef = React.useRef(null);
  const [autoOpen, setAutoOpen] = useState(false)
  const [arrHide, setArrHide] = useState({
    material: [],
    work: [],
    textField: [],
  })
  const types = useSelector(state => state.form[formTypeRow]?.values || {
    material: true,
    work: true,
    textField: true,
  })
  const handleToggle = (value, old) => {
    dispatch(processActionHide(old,value, formName, formTypeRow, arrHide, setArrHide));
  }
  const handleAutoClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setAutoOpen(false);
  };
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setAutoOpen(false);
    }
  }
  return (
    <React.Fragment>
      <Button color="primary" onClick={() => setAutoOpen(e => !e)} size='large' ref={anchorRef}>Тип</Button>
      <Popover
        open={autoOpen}
        anchorEl={anchorRef.current}
        role={undefined}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleAutoClose}
      >
        <div className='App-paper'>
          <ClickAwayListener onClickAway={handleAutoClose}>
            <MenuList autoFocusItem={autoOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
              {typeGant.filter(e => typesView.has(e.value)).map(item => {
                const selected = types[item.value]
                return <MenuItem
                  key={item.value}
                  onClick={(e) => handleToggle(item.value, selected)}
                  selected={selected}>{item.label}</MenuItem>
              })}
            </MenuList>
          </ClickAwayListener>
        </div>
      </Popover>
    </React.Fragment>

  );
}